import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UseCase } from '../../base';
import { MapProvider } from '../../domain/models/map-provider.model';
import { MapProviderRepository } from '../../repositories/map-provider.repository';

@Injectable({ providedIn: 'root' })
export class GetMapProviderUsecase implements UseCase< null,MapProvider[]> {
  constructor(private readonly mapProviderRepository: MapProviderRepository) {}

  execute(): Observable<MapProvider[]> {
    return this.mapProviderRepository.getMapProviders();
  }
}